import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { WriteOffSource } from "@me-team/common/src/interfaces/interfaces";

type UseNavigateWithToastParams = {
    branchId: string;
    bookingUuid: string;
    writeOffSource: WriteOffSource;
};

const useNavigateWithToast = ({ branchId, bookingUuid, writeOffSource }: UseNavigateWithToastParams) => {
    const navigate = useNavigate();
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const isFromLogbook = query.get("isFromLogbook");

    return useCallback(
        (textToProvide: string) => {
            if (!location.state || !location.state.comeFrom) {
                navigate(
                    writeOffSource === "logbook"
                        ? `/logbook/journal/${branchId}`
                        : `/warehouses/operations/${branchId}`,
                    {
                        state: {
                            text: textToProvide,
                            toast: true,
                        },
                    }
                );
            }

            if (location.state && location.state.comeFrom.isFromOperations) {
                navigate(`/warehouses/operations/${branchId}`, {
                    state: {
                        text: textToProvide,
                        toast: true,
                    },
                });
            }

            if (location.state && location.state.comeFrom.isFromRecord) {
                navigate(`/logbook/edit-record/${bookingUuid}/${branchId}`, {
                    state: {
                        text: textToProvide,
                        toast: true,
                    },
                });
            }

            if (location.state && location.state.comeFrom.isFromClientsHistory) {
                navigate(`/clients-history-visit/${branchId}`, {
                    state: {
                        text: textToProvide,
                        toast: true,
                    },
                });
            }

            if (isFromLogbook) {
                navigate(`/logbook/journal/${branchId}`, {
                    state: {
                        text: textToProvide,
                        toast: true,
                    },
                });
            }
        },
        [location.state, branchId, bookingUuid, navigate, isFromLogbook, writeOffSource]
    );
};

export default useNavigateWithToast;
